export default {"src":"/_next/static/media/Share.bb4e69f1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};